import { CalendarDays, Check, Share2, X } from 'lucide-react';
import { toast } from 'react-hot-toast';

export type HeaderActionsProps = {
  isDirty: boolean;
  isScheduleEvent: boolean;
  onSave: () => void;
  onCancel: () => void;
  onScheduleEvent?: () => void;
};

const shareLink = async () => {
  const link = typeof window !== 'undefined' ? window.location.href : '';
  try {
    await navigator.clipboard.writeText(link);
    toast.success('Link copied to clipboard');
  } catch (e) {
    prompt('Copy this link', link);
    console.warn('Clipboard copy failed, fallback to prompt:', e);
  }
};

const EventActions = ({
  isDirty,
  isScheduleEvent,
  onSave,
  onCancel,
  onScheduleEvent,
}: HeaderActionsProps) => {
  return (
    <div className="flex flex-wrap items-center gap-2 shrink-0 w-full md:w-auto">
      {/* Schedule Event */}
      {onScheduleEvent && (
        <button
          onClick={onScheduleEvent}
          disabled={isScheduleEvent}
          className="flex items-center justify-center gap-2 px-3 py-2.5 border border-blue-600 rounded-lg text-white text-sm font-semibold bg-blue-600 hover:bg-blue-700 active:bg-blue-800 disabled:opacity-50 disabled:cursor-not-allowed min-h-[44px] w-full sm:w-auto">
          <CalendarDays className="w-4 h-4 flex-shrink-0 hidden sm:block" />
          <span className="whitespace-nowrap">Schedule Event</span>
        </button>
      )}

      {/* Share Link */}
      <button
        onClick={shareLink}
        className="flex items-center justify-center gap-2 px-3 py-2.5 border border-emerald-200 rounded-lg text-sm font-semibold text-emerald-700 bg-emerald-50 hover:bg-emerald-100 active:bg-emerald-200 min-h-[44px] w-full sm:w-auto">
        <Share2 className="w-4 h-4 flex-shrink-0 hidden sm:block" />
        <span className="whitespace-nowrap">Share Link</span>
      </button>

      {/* Cancel */}
      <button
        onClick={onCancel}
        disabled={!isDirty}
        className={
          'flex items-center justify-center gap-2 px-3 py-2.5 border rounded-lg text-sm font-semibold min-h-[44px] w-full sm:w-auto ' +
          (isDirty
            ? 'text-red-600 border-red-200 bg-red-50 hover:bg-red-100 active:bg-red-200'
            : 'text-gray-400 border-gray-200 bg-gray-100 cursor-not-allowed')
        }>
        <X className="w-4 h-4 flex-shrink-0 hidden sm:block" />
        <span className="whitespace-nowrap">Cancel</span>
      </button>

      {/* Save */}
      <button
        onClick={onSave}
        disabled={!isDirty}
        className={
          'flex items-center justify-center gap-2 px-4 py-2.5 border border-gray-200 rounded-lg text-sm font-semibold min-h-[44px] w-full sm:w-auto ' +
          (isDirty
            ? 'bg-green-600 text-white hover:bg-green-700 active:bg-green-800'
            : 'bg-gray-200 text-gray-500 cursor-not-allowed')
        }>
        <Check className="w-4 h-4 flex-shrink-0 hidden sm:block" />
        <span className="whitespace-nowrap inline-block min-w-[44px] text-center">
          {isDirty ? 'Save' : 'Saved'}
        </span>
      </button>
    </div>
  );
};

export default EventActions;
